export default "__VITE_ASSET__DAaF1OtQ__"